import React from 'react';
import { Send, Shield, Percent, Clock } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
export function HeroSection() {
  const {
    openForm
  } = useLeadForm();
  return <section className="relative min-h-screen bg-[#0A1A3F] text-white flex flex-col justify-center px-5 py-12 md:px-12 lg:px-24" data-id="element-61">
      {/* Logo */}
      <div className="absolute top-5 left-5 md:top-8 md:left-12" data-id="element-62">
        <div className="bg-[#228B22] text-white font-heading font-bold text-sm px-4 py-2 rounded-lg tracking-wide" data-id="element-63">
          ПРОФПАРК
        </div>
      </div>

      <div className="mt-16 max-w-2xl mx-auto w-full md:text-center" data-id="element-64">
        {/* Dealer badge */}
        <div className="mb-5" data-id="element-65">
          <span className="inline-block bg-white/10 border border-white/20 text-white/90 text-xs font-medium px-3 py-1.5 rounded-full" data-id="element-66">
            Легендарные японские тракторы Kubota
          </span>
        </div>

        {/* Headline */}
        <h1 className="font-heading font-bold text-[36px] leading-[1.15] md:text-[48px] md:leading-[1.1] mb-5" data-id="element-67">
          Тракторы от 21 до 95&nbsp;л.с.
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/75 leading-relaxed mb-8" data-id="element-68">
          Доставка до дома, возможность получения лизинга, сервис и оригинальные
          запчасти.
        </p>

        {/* CTA */}
        <button onClick={openForm} className="flex items-center justify-center gap-2.5 w-full md:w-auto md:inline-flex bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-lg min-h-[56px] px-8 rounded-2xl transition-colors cursor-pointer" data-id="element-69">
          <Send className="w-5 h-5" data-id="element-70" />
          Оставить заявку
        </button>

        {/* Sub-CTA text */}
        <p className="text-sm text-white/50 mt-3 md:text-center" data-id="element-71">
          Перезвоним за 15 минут · Бесплатная консультация
        </p>

        {/* Mini badges */}
        <div className="flex flex-wrap gap-3 mt-8 md:justify-center" data-id="element-72">
          <div className="flex items-center gap-2 bg-white/10 border border-white/15 rounded-xl px-4 py-2.5" data-id="element-73">
            <Shield className="w-4 h-4 text-[#25D366]" data-id="element-74" />
            <span className="text-sm font-medium" data-id="element-75">
              Гарантия 3 года или 1500 моточасов
            </span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 border border-white/15 rounded-xl px-4 py-2.5" data-id="element-76">
            <Percent className="w-4 h-4 text-[#25D366]" data-id="element-77" />
            <span className="text-sm font-medium" data-id="element-78">Программы лизинга</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 border border-white/15 rounded-xl px-4 py-2.5" data-id="element-79">
            <Clock className="w-4 h-4 text-[#25D366]" data-id="element-80" />
            <span className="text-sm font-medium" data-id="element-81">Доставка по РК</span>
          </div>
        </div>
      </div>
    </section>;
}